namespace GeniuzPOS.Purchase {
    export class PoPayTermCodeColumns {
        static columnsKey = 'Purchase.PoPayTermCode';
    }
}
